// this component handles what we want to put in <head> e.g scripts, styles, meta-description
// the required package is react-helmet and the gatsby-plugin-react-helmet
import React from "react"
import Helmet from "react-helmet"

const Head = ({pageTitle, lang}) => <Helmet>
	<title>{`${lang.head.title}  | ${pageTitle}`}</title>
	<meta charset="utf-8" />
	<meta http-equiv="x-ua-compatible" content="ie=edge"/>
	<meta name="description" content={lang.head.description} />
	<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
	<meta name="viewport" content="user-scalable=no,width=device-width" />
	<meta property="og:url" content="https://online.berjayasompo.com.my/cimb/staff/" />
	<meta property="og:type" content="website" />
	<meta property="og:title" content={`${lang.head.title}  | ${pageTitle}`} />
	<meta property="og:description" content={lang.head.description} />
	<meta property="og:image" content="/cimb/staff/images/metatag/motor.jpg" />
  <link rel="icon" href="/cimb/staff/images/favicon.ico"></link>
	{/* path maps to public folder, everything in static folder will be moved to public during build 
	so the /css/ folder below maps to static/css/ */}
	{/* <link href="/motorNow/css/bootstrap.min.css" rel="stylesheet" /> */}
  {/* {<!-- Google Tag Manager -->} */}
  <script>
    {`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PM577QT');
    `}
  </script>
  <script src="https://stackpath.bootstrapcdn.com/bootstrap/5.0.0-alpha1/js/bootstrap.min.js" integrity="sha384-oesi62hOLfzrys4LxRF63OJCXdXDipiYWBnvTl9Y9/TRlw5xlKIEHpNyvvDShgf/" crossorigin="anonymous"></script>
</Helmet>

export default Head